import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button,Col, Input, Row} from 'reactstrap'; 

import FormModal from '../../../../components/Admin/FormModal/FormModal';
import FormFieldClass from '../../../../components/Admin/FormModal/FormFieldClass';
import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';
import { Wrapper, Content , ContentRow} from './ListInteractionSets.styles'
import {Modal, ModalBody, ModalHeader} from 'reactstrap';

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class ListAssetCollections extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.goToEdit = this.goToEdit.bind(this);
        this.onGoToCreate = this.onGoToCreate.bind(this);
        this.setToggle = this.setToggle.bind(this);
        this.setSubmit = this.setSubmit.bind(this);
        this.uploadModalToggle = this.uploadModalToggle.bind(this);
        this.deptSubmit = this.deptSubmit.bind(this);

    }

    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'home/';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onGoToCreate() {
        const dest = this.props.services.currentBaseUrl + 'interactions_creator';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public setToggle() {
        const data = this.state.data
        data.setModal = !data.setModal;
        this.setState({
            data
         });
    }

    public async setSubmit(e) {

        e.preventDefault();

        this.setState({
            loaded: false
         });

        const item = this.state.data.setFormValues;

        const res = await this.props.services.adminAPI.createItemGeneral('interaction_sets', item);

        if (res.ok) {
            this.setToggle();

            const coursesRes = await this.props.services.adminAPI.getInteractionSetsOverview();
            
            if(coursesRes.ok) {
                const data = this.state.data;

                data.collections = coursesRes.data.interaction_sets;
            
                this.setState({
                    data
                 });
            }
        }
        else{
            toast.error('Error creating item!');
        }

        this.setState({
            loaded: true
        });
    }


    public async goToEdit(row) {
        console.log(row);
        const dest = this.props.services.currentBaseUrl + 'interaction_sets/' + row.rowData.id
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public async interactionDelete(row) {
        console.log(row.rowData.id);

        const retVal = confirm("Do you want to continue ?");
    
        if(retVal === true) {
                  console.log('delete accepted');
                  const res = await this.props.services.adminAPI.deleteItemGeneral('interaction_sets', row.rowData.id);
                  if (res.ok) {
                    const InteractionsRes = await this.props.services.adminAPI.getInteractionSetsOverview();
                  
                    if(InteractionsRes.ok) {
                        const collections = InteractionsRes.data.interaction_sets;

                        const data = this.state.data;

                        data.collections = collections;

                        this.setState({data});
                    }
                    
                }
                  return true;
        } else {
            console.log('delete canceled')
            return false;
        }
    }

    public customTD = props =>{
        return (
          <td>
            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button style={{margin: '3px'}} className="blue-button view-more-data table-action" onClick={() => this.goToEdit(props)}>Edit</button>

            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button style={{margin: '3px'}} className="blue-button view-more-data table-action" onClick={() => this.interactionDelete(props)}>Delete</button>
          </td>
        );
    } 

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: InteractionID } } = match;

        const assetCollectionsDataKey = ["id", "Title", "Description", "Created", "Creator","delete"];
        
        const assetCollectionsThead = ["ID", "Name", "Description", "Date", "Creator", "Action"];


        const setFormFields = [
            {
                id: 'name',
                name: 'Name',
                type: 'text',
                placeholder: 'Enter Name',
                required: true
            },
            {
                id: 'description',
                name: 'Description',
                type: 'text',
                placeholder: 'Enter Description',
                required: true
            }
        ] as FormFieldClass[];

        const setFormValues = {
            description: '',
            user: currentUserID,
            name: '',
        }

        const assetCollectionsRes = await adminAPI.getInteractionSetsOverview();

        if (assetCollectionsRes.ok) {
            
            const collections = assetCollectionsRes.data.interaction_sets;

            this.setState(
                {
                     data: {
                        collections,
                        loaded: true,
                        collectionsdatakey: assetCollectionsDataKey,
                        collectionsthead: assetCollectionsThead,
                        setModal: false,
                        setFormFields,
                        setFormValues,
                        uploading: false,
                        uploadModal: false
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    public uploadModalToggle () {
        const data = this.state.data;

        data.uploadModal = !data.uploadModal;

        this.setState({data});

    }

    public async deptSubmit(e) {
        e.preventDefault();

        const data = this.state.data;

        data.uploading = true;

        this.setState({data});

        const fileInputElement = e.target.elements.upld;
        const formData = new FormData();

        for (const row of fileInputElement.files) {
            formData.append('files', row);
        }

        const res = await this.props.services.adminAPI.updloadInteractionZip(formData)
    
        
        if (res.ok) {
            const setsRes = await this.props.services.adminAPI.getInteractionSetsOverview();
        
            if (setsRes.ok) {

                const collections = setsRes.data.interaction_sets;

                const data = this.state.data;

                data.collections = collections;

                data.uploading = false;

                data.uploadModal = false;
                
                this.setState({data});

                toast.success("Success");
            }
        }

        else {
            toast.error("Failed to complete upload");
        }

        data.uploading = false;
                
        this.setState({data});
        
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>

              <Content>
                <Button onClick={this.setToggle}>Add New</Button> 

                <Button style={{marginLeft: '3px', marginRight: '3px'}} onClick={this.uploadModalToggle}>Upload Zip</Button>

                <a href="https://plexdata.s3.eu-west-2.amazonaws.com/samples/pl_interaction_template.zip" target="_blank">Download Template</a>

                <SortableTbl
                    tblData={data.collections}
                    tHead={data.collectionsthead}
                    dKey={data.collectionsdatakey}
                    customTd={[
                            { custd: this.customTD, keyItem: "edit", sortable: false },
                            { custd: this.customTD, keyItem: "delete", sortable: false }
                        ]}
                    defaultCSS={false}
                />

              </Content>

              <ContentRow>
            
                    <FormModal 
                        visible={data.setModal}
                        toggle={this.setToggle}
                        formsubmit={this.setSubmit}
                        formfields = {data.setFormFields}
                        values={data.setFormValues}
                        isbusy={!this.state.loaded}
                    />

                    <Modal isOpen={data.uploadModal} toggle={this.uploadModalToggle} style={{marginTop: '10%'}}>
                        <ModalHeader toggle={this.uploadModalToggle}> Interactions Upload</ModalHeader>
                        <ModalBody>
                        <form onSubmit={this.deptSubmit}>
                            <Row>
                                <Col xs="12">
                                    <input id="upld" type="file" name="upld" accept=".zip" multiple={false} required={true}/>
                                </Col>


                                <Loader color="#3EE9F7" loaded={!data.uploading}>
                                    <Button color="primary" type="submit" className="adminmodalbutton">Submit</Button>
                                    <Button  onClick={this.uploadModalToggle} className="adminmodalbutton">Cancel</Button>
                                </Loader>

                                </Row>
                            </form>
                    </ModalBody>
                </Modal>
                    
                </ContentRow>

              
              </Wrapper>
        );

    }

}

export default withServices(ListAssetCollections);


// WEBPACK FOOTER //
// ./src/pages/Admin/InteractionSets/ListInteractionSets/ListInteractionSets.tsx